module.exports = __webpack_public_path__ + "static/media/599.7554(33).038a409c.pdf";